/* Tooltip + HelpTip — CSS hover tooltip and inline help icon trigger.
   Ported from lib/components.jsx (claude_design project 5c0836b6-facf-49dd-9c78-62afe3f7bc12). */

import React from 'react';
import { Icon } from './Icon';

export interface TooltipProps {
  label: React.ReactNode;
  children: React.ReactNode;
}

export function Tooltip({ label, children }: TooltipProps) {
  return (
    <span className="tip">
      {children}
      <span className="tip-content">{label}</span>
    </span>
  );
}

export interface HelpTipProps {
  label: React.ReactNode;
}

export function HelpTip({ label }: HelpTipProps) {
  return (
    <Tooltip label={label}>
      <span
        style={{
          color: 'var(--text-faint)',
          display: 'inline-flex',
          cursor: 'help',
        }}
      >
        <Icon name="help-circle" size={14} />
      </span>
    </Tooltip>
  );
}

export default Tooltip;
